import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import ProtectedRoute from './components/ProtectedRoute';
import { RouteErrorBoundary } from './components/ErrorBoundary';
import ThemeInitializer from './components/ThemeInitializer';
import Passport from './pages/Passport';
import Home from './pages/Home';
import NewEvent from './pages/NewEvent';
import EventDetail from './pages/EventDetail';
import Settings from './pages/Settings';
import Login from './pages/Login';
import Register from './pages/Register';
import AddFriend from './pages/AddFriend';
import AddStamp from './pages/AddStamp';
import FriendsEventFeed from './pages/FriendsEventFeed';
import Stats from './pages/Stats';
import AdminDashboard from './pages/AdminDashboard';
import DiscoveredEventPreview from './pages/DiscoveredEventPreview';
import Onboarding from './pages/Onboarding';
import SchedulePlanner from './pages/SchedulePlanner';
import Discover from './pages/Discover';

function App() {

  return (
    <div>
      <AuthProvider>
        <ThemeProvider>
          <ThemeInitializer>
            <BrowserRouter>
          {/* Inside the router so it can reset on navigation and offer a
              working way back; outside Routes so a crash in any page still
              renders the fallback rather than a blank document. */}
          <RouteErrorBoundary>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path='/onboarding' element={
              <ProtectedRoute requireProfileComplete={false}>
                <Onboarding />
              </ProtectedRoute>
            } />
            <Route path='/home' element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }/>
            <Route path='/passport' element={
              <ProtectedRoute>
                <Passport />
              </ProtectedRoute>
            } />
            <Route path='/passport/:userId' element={
              <ProtectedRoute>
                <Passport />
              </ProtectedRoute>
            } />
            <Route path='/newEvent' element={
              <ProtectedRoute>
                <NewEvent />
              </ProtectedRoute>
            } />
            <Route path='/discover' element={
              <ProtectedRoute>
                <Discover />
              </ProtectedRoute>
            } />
            <Route path='/discover/event' element={
              <ProtectedRoute>
                <DiscoveredEventPreview />
              </ProtectedRoute>
            } />
            <Route path='/editEvent/:id' element={
              <ProtectedRoute>
                <NewEvent mode="edit" />
              </ProtectedRoute>
            } />
            <Route path='/event/:id' element={
              <ProtectedRoute>
                <EventDetail />
              </ProtectedRoute>
            } />
            <Route path='/event/:id/schedule' element={
              <ProtectedRoute>
                <SchedulePlanner />
              </ProtectedRoute>
            } />
            <Route path='/settings' element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            } />
            <Route path='/add-friend' element={
              <ProtectedRoute>
                <AddFriend />
              </ProtectedRoute>
            } />
            <Route path='/add-stamp' element={
              <ProtectedRoute>
                <AddStamp />
              </ProtectedRoute>
            } />
            <Route path='/friends-feed' element={
              <ProtectedRoute>
                <FriendsEventFeed />
              </ProtectedRoute>
            } />
            <Route path='/stats' element={
              <ProtectedRoute>
                <Stats />
              </ProtectedRoute>
            } />
            <Route path='/admin' element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } />
          </Routes>
          </RouteErrorBoundary>
            </BrowserRouter>
          </ThemeInitializer>
        </ThemeProvider>
      </AuthProvider>
    </div>
  );
}
export default App;
